export enum DiscoverFilterFields {
  publicKeyBase58Check = "publicKeyBase58Check",
  lockedReferralRewardsUsdCents = "lockedReferralRewardsUsdCents",
  twitterUsername = "twitterUsername",
  twitterTotalFollowers = "twitterTotalFollowers",
  twitterTotalFollowing = "twitterTotalFollowing",
  twitterTotalTweets = "twitterTotalTweets",
  unlockedJoiningRewardUsdCents = "unlockedJoiningRewardUsdCents",
  totalReferralRewardsUsdCents = "totalReferralRewardsUsdCents",
  lockedJoiningRewardUsdCents = "lockedJoiningRewardUsdCents",
  unlockedReferralRewardsUsdCents = "unlockedReferralRewardsUsdCents",
  desoBalanceNanos = "desoBalanceNanos",
  usdcBalanceUsdCents = "usdcBalanceUsdCents",
  usdtBalanceUsdCents = "usdtBalanceUsdCents",
  totalPosts = "totalPosts",
  totalFocusPostViews = "totalFocusPostViews",
  totalFocusPostWhaleViews = "totalFocusPostWhaleViews",
  totalViewedFocusPosts = "totalViewedFocusPosts",
  totalFocusEarningsUsdCents = "totalFocusEarningsUsdCents",
  totalSubscriptionEarningsUsdCents = "totalSubscriptionEarningsUsdCents",
  totalJoiningRewardUsdCents = "totalJoiningRewardUsdCents",
  totalDiamondsUsdCentsSent = "totalDiamondsUsdCentsSent",
  totalFollowers = "totalFollowers",
  totalWhaleFollowers = "totalWhaleFollowers",
  totalFollowing = "totalFollowing",
  totalAssetsBalanceUsdCents = "totalAssetsBalanceUsdCents",
  totalLiquidAssetsBalanceUsdCents = "totalLiquidAssetsBalanceUsdCents",
  totalReactionsReceived = "totalReactionsReceived",
  // TODO check received: probably it can be changed
  totalPositiveReactionsReceived = "totalPositiveReactionsReceived",
  totalNegativeReactionsReceived = "totalNegativeReactionsReceived",
  totalReactionsGiven = "totalReactionsGiven",
  totalPositiveReactionsGiven = "totalPositiveReactionsGiven",
  totalNegativeReactionsGiven = "totalNegativeReactionsGiven",
  totalDiamondsUsdCentsReceived = "totalDiamondsUsdCentsReceived",
  username = "username",
  description = "description",
  twitterIsVerified = "twitterIsVerified",
  joinedFocusDate = "joinedFocusDate",
  totalReactions = "totalReactions",
  totalPaidMessageEarningsUsdCents = "totalPaidMessageEarningsUsdCents",
  tokenAmmLaunchAt = "tokenAmmLaunchAt",
  tokenAmmCreatedAt = "tokenAmmCreatedAt",
  marketCapUsd = "marketCapUsd",
}

export const SORT_KEYS: Partial<Record<DiscoverFilterFields, string>> = {
  [DiscoverFilterFields.tokenAmmLaunchAt]: "TOKEN_AMM_LAUNCH_AT",
  [DiscoverFilterFields.tokenAmmCreatedAt]: "TOKEN_AMM_CREATED_AT",
  [DiscoverFilterFields.publicKeyBase58Check]: "PUBLIC_KEY_BASE58_CHECK",
  [DiscoverFilterFields.totalSubscriptionEarningsUsdCents]:
    "TOTAL_SUBSCRIPTION_EARNINGS_USD_CENTS",
  [DiscoverFilterFields.twitterUsername]: "TWITTER_USERNAME",
  [DiscoverFilterFields.twitterTotalFollowers]: "TWITTER_TOTAL_FOLLOWERS",
  [DiscoverFilterFields.twitterTotalFollowing]: "TWITTER_TOTAL_FOLLOWING",
  [DiscoverFilterFields.twitterTotalTweets]: "TWITTER_TOTAL_TWEETS",
  [DiscoverFilterFields.desoBalanceNanos]: "DESO_BALANCE_NANOS",
  [DiscoverFilterFields.usdcBalanceUsdCents]: "USDC_BALANCE_USD_CENTS",
  [DiscoverFilterFields.usdtBalanceUsdCents]: "USDT_BALANCE_USD_CENTS",
  [DiscoverFilterFields.totalPosts]: "TOTAL_POSTS",
  [DiscoverFilterFields.totalFocusPostViews]: "TOTAL_FOCUS_POST_VIEWS",
  [DiscoverFilterFields.totalFocusPostWhaleViews]:
    "TOTAL_FOCUS_WHALE_POST_VIEWS",
  [DiscoverFilterFields.totalViewedFocusPosts]: "TOTAL_VIEWED_FOCUS_POSTS",
  [DiscoverFilterFields.totalFocusEarningsUsdCents]:
    "TOTAL_FOCUS_EARNINGS_USD_CENTS",
  [DiscoverFilterFields.totalJoiningRewardUsdCents]:
    "TOTAL_JOINING_REWARD_USD_CENTS",
  [DiscoverFilterFields.totalDiamondsUsdCentsSent]:
    "TOTAL_DIAMONDS_USD_CENTS_SENT",
  [DiscoverFilterFields.totalFollowers]: "TOTAL_FOLLOWERS",
  [DiscoverFilterFields.totalWhaleFollowers]: "TOTAL_WHALE_FOLLOWERS",
  [DiscoverFilterFields.totalFollowing]: "TOTAL_FOLLOWING",
  [DiscoverFilterFields.totalAssetsBalanceUsdCents]:
    "TOTAL_ASSETS_BALANCE_USD_CENTS",
  [DiscoverFilterFields.totalLiquidAssetsBalanceUsdCents]:
    "TOTAL_LIQUID_ASSETS_BALANCE_USD_CENTS",
  [DiscoverFilterFields.totalReactionsReceived]: "TOTAL_REACTIONS_RECEIVED",
  [DiscoverFilterFields.totalPositiveReactionsReceived]:
    "TOTAL_POSITIVE_REACTIONS_RECEIVED",
  [DiscoverFilterFields.totalNegativeReactionsReceived]:
    "TOTAL_NEGATIVE_REACTIONS_RECEIVED",
  [DiscoverFilterFields.totalReactionsGiven]: "TOTAL_REACTIONS_GIVEN",
  [DiscoverFilterFields.totalPositiveReactionsGiven]:
    "TOTAL_POSITIVE_REACTIONS_GIVEN",
  [DiscoverFilterFields.totalNegativeReactionsGiven]:
    "TOTAL_NEGATIVE_REACTIONS_GIVEN",
  [DiscoverFilterFields.totalDiamondsUsdCentsReceived]:
    "TOTAL_DIAMONDS_USD_CENTS_RECEIVED",
  [DiscoverFilterFields.username]: "USERNAME",
  [DiscoverFilterFields.description]: "DESCRIPTION",
  [DiscoverFilterFields.twitterIsVerified]: "TWITTER_IS_VERIFIED",
  [DiscoverFilterFields.joinedFocusDate]: "JOINED_FOCUS_DATE",
  [DiscoverFilterFields.totalReactions]: "TOTAL_REACTIONS",
  [DiscoverFilterFields.totalPaidMessageEarningsUsdCents]:
    "TOTAL_PAID_MESSAGE_EARNINGS_USD_CENTS",
  [DiscoverFilterFields.marketCapUsd]: "MARKET_CAP_USD",
};

export enum TimePeriod {
  AllTime = "AllTime",
  Past24H = "Past24H",
  Past7D = "Past7D",
  Past30D = "Past30D",
}

export const TIME_RANGE_SORT_KEYS = {
  [TimePeriod.AllTime]: "ALL_TIME",
  [TimePeriod.Past24H]: "PAST_24H",
  [TimePeriod.Past7D]: "PAST_7D",
  [TimePeriod.Past30D]: "PAST_30D",
};

export const SORT_VALUE_MAP = {
  asc: "ASC",
  desc: "DESC",
};
